import { render, staticRenderFns } from "./JanCode.vue?vue&type=template&id=580f8191&scoped=true&"
import script from "./JanCode.vue?vue&type=script&lang=ts&"
export * from "./JanCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f8191",
  null
  
)

export default component.exports